export const API_URL = "https://task-manager-dun.vercel.app"

//vercel : https://task-manager-dun.vercel.app